import { DEFAULT_ATTRIBUTE } from '@/components/vehicle-detail-header-filter/utils/constants';
import type { HsiycSearchVehiclesRecord } from '@/types/legacy-api/graphql';
import type { VehicleFilterState } from '@/components/v2/vehicle-variants/types';

const getNextVehicle = (state: VehicleFilterState): HsiycSearchVehiclesRecord | undefined => {
  const { vehicles, dynamicFilters } = state;
  const defaultAttributeName = DEFAULT_ATTRIBUTE?.name;
  if (!defaultAttributeName) {
    return undefined;
  }

  const lastFilter = dynamicFilters.find(({ label }) => label === defaultAttributeName);
  const selectedOption = lastFilter?.selectedOption;

  return vehicles.find(({ redbookCode }) => redbookCode === selectedOption?.id);
};

export default getNextVehicle;
